import React, { useState } from "react";
import { Card, Row, Col, Button, Table, Modal, Spin, Tag, Typography } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import RoleForm from "./roleForm";
import useFetchWithToken from "../../services/api2";

const { Title } = Typography;

const Role = () => {
  const [roleModalVisible, setRoleModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const { data: roleData, loading, error, refetchData } = useFetchWithToken("roles");

  const handleAddRole = () => {
    setFormData({});
    setRoleModalVisible(true);
  };

  const handleEditRole = (record) => {
    setFormData(record);
    setRoleModalVisible(true);
  };

  const handleDeleteRole = (roleId) => {
    // Implement deletion logic here
  };

  const closeModal = () => {
    setRoleModalVisible(false);
  };

  const roleColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Permissions",
      dataIndex: "Permissions",
      key: "permissions",
      render: (permissions) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {permissions &&
            permissions.map((permission) => (
              <Tag key={permission.id} color="blue">
                {permission.name}
              </Tag>
            ))}
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditRole(record)}
            style={{ color: "#0c8c49", marginRight: 8 }}
          >
            Edit
          </Button>
          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteRole(record.id)}
            style={{ color: "red" }}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Manage Roles
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddRole}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Role
            </Button>
          </Col>
        </Row>
        {error ? (
          <div style={{ textAlign: "center", color: "red" }}>Error: {error}</div>
        ) : loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            dataSource={roleData}
            columns={roleColumns}
            pagination={{ pageSize: 5 }}
            rowKey="id"
            bordered
          />
        )}
      </Card>

      <Modal
        title={formData?.id ? "Edit Role" : "Add Role"}
        visible={roleModalVisible}
        onCancel={closeModal}
        footer={null}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <RoleForm
          formData={formData}
          setFormData={setFormData}
          closeModal={closeModal}
          refetchData={refetchData}
        />
      </Modal>
    </div>
  );
};

export default Role;
